var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"presentation-iframe__wrap"},[_c('iframe',{staticClass:"presentation-iframe",attrs:{"id":"presentation","src":_vm.presentationUrl,"allowfullscreen":"","scrolling":"no","frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }